import { defineComponent, ref, watch } from '@vue/composition-api';
import ArrowSvg from '@/assets/icons/arrow-down.svg';
import { Icon, IconSize } from '@/components/Icon';
import ObjectsTreePlace from './ObjectsTreePlace.vue';
export default defineComponent({
    name: 'ObjectsTreeNode',
    components: {
        Icon,
        ObjectsTreePlace,
    },
    props: {
        structure: {
            type: Object,
            required: true,
        },
        defaultExpanded: {
            type: Boolean,
            default: false,
        },
    },
    setup(props) {
        const isExpanded = ref(props.defaultExpanded);
        watch(() => props.defaultExpanded, (expanded) => {
            isExpanded.value = expanded;
        });
        return {
            isExpanded,
            ArrowSvg,
            IconSize,
        };
    },
});
